import { ACADEMY } from "../lib/academy-data";
import { CheckCircle2, GraduationCap, Home as HomeIcon, Salad, BookOpen } from "lucide-react";

const HIGHLIGHTS = [
  {
    icon: GraduationCap,
    title: "לימודים בתיכון החקלאי עין כרם",
    description:
      "שילוב מיטבי בין ספורט ללימודים. מגמות הכוללות פיזיקה, מחשבים, חינוך גופני ועוד, עם סיוע בשעות פרטניות.",
  },
  {
    icon: HomeIcon,
    title: "פנימיה מלאה",
    description:
      "מגורים בבתי הפנימיה, 2-3 שחקנים בחדר. אפשרות לחזור הביתה ללילה אחד באמצע השבוע ובסופי שבוע.",
  },
  {
    icon: Salad,
    title: "תזונה מותאמת",
    description:
      "שלוש ארוחות ביום (בוקר, צהריים, ערב), פריסת ארבע ופריסת לילה. תפריט שנבנה לאחר ייעוץ תזונתי מקיף.",
  },
  {
    icon: BookOpen,
    title: "מרכז למידה",
    description:
      "הפנימיה מעמידה לרשות הספורטאים מרכז למידה. מדריכי הפנימיה בקשר שוטף עם המורים והמחנכים.",
  },
];

export default function About() {
  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="relative py-24 md:py-32 overflow-hidden bg-[#0A0A0A]">
        <img
          src="https://images.unsplash.com/photo-1767478653130-cf314528da32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxiYXNrZXRiYWxsJTIwcGxheWVyJTIwYWN0aW9uJTIwZGFyayUyMGNvdXJ0fGVufDB8fHx8MTc3NzQ0ODI1N3ww&ixlib=rb-4.1.0&q=85"
          alt="כדורסל"
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-[#0A0A0A] to-[#0A0A0A]/70" />
        <div className="container mx-auto px-6 md:px-10 relative">
          <p className="font-heading text-xs md:text-sm font-bold tracking-[0.3em] text-[#DC2626] uppercase mb-4">
            אודות האקדמיה
          </p>
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-black text-white uppercase tracking-tight leading-[0.9] max-w-4xl">
            הפלטפורמה האידיאלית
            <br />
            <span className="text-[#DC2626]">לספורטאי הצעיר.</span>
          </h1>
          <p className="font-body text-lg md:text-xl text-neutral-300 mt-6 leading-relaxed max-w-3xl">
            אקדמיית כדורסל המיועדת לבנים ובנות מגיל 14 ומעלה (כיתות ט'-י"ב), שמטרתה לתת מענה
            לספורטאים מוכשרים שרוצים להשקיע בכדורסל, לבנות את האישיות שלהם ולהגיע לרמות הגבוהות.
          </p>
        </div>
      </section>

      {/* Story / Manager */}
      <section className="py-20 md:py-24 bg-[#050505]">
        <div className="container mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 relative">
            <div className="absolute -top-3 -right-3 w-full h-full border-2 border-[#DC2626]" />
            <img
              src="https://images.pexels.com/photos/6767224/pexels-photo-6767224.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700"
              alt="מאמן"
              className="relative w-full h-[520px] object-cover"
            />
          </div>
          <div className="lg:col-span-7">
            <p className="font-heading text-xs md:text-sm font-bold tracking-[0.3em] text-[#DC2626] uppercase mb-3">
              ההובלה המקצועית
            </p>
            <h2 className="font-heading text-4xl md:text-5xl font-black text-white uppercase tracking-tight leading-[0.95]">
              ליווי מקצועי צמוד
              <br />
              של <span className="text-[#DC2626]">{ACADEMY.leadProfessional}</span>
            </h2>
            <p className="font-body text-base md:text-lg text-neutral-300 mt-6 leading-relaxed">
              התכנית מנוהלת בליווי מקצועי צמוד של <strong className="text-white">{ACADEMY.leadProfessional}</strong>,
              ובניהול <strong className="text-white">{ACADEMY.manager}</strong> — מנהל מקצועי בהפועל מטה יהודה,
              עוזר מאמן מכבי אשדוד בליגת העל גברים, ובעל ניסיון רב באימון קבוצות נוער, נערים וילדים.
            </p>
            <p className="font-body text-base md:text-lg text-neutral-300 mt-4 leading-relaxed">
              צוות האקדמיה כולל את מאמני מחלקת הנוער של הפועל מטה יהודה, מאמן יכולות גופניות,
              ומאמן מנטלי — <strong className="text-white">{ACADEMY.mentalCoach}</strong>, מרצה ויועץ בתחום הספורט וההעצמה האישית.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4 max-w-md">
              <div className="bg-[#171717] border border-white/10 p-5">
                <div className="font-heading text-3xl font-black text-[#DC2626]">14+</div>
                <div className="font-body text-sm text-neutral-400 mt-1">בנים ובנות</div>
              </div>
              <div className="bg-[#171717] border border-white/10 p-5">
                <div className="font-heading text-3xl font-black text-[#DC2626]">3</div>
                <div className="font-body text-sm text-neutral-400 mt-1">קודקודי המשולש</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Highlights */}
      <section className="py-24 md:py-28 bg-[#0A0A0A]" data-testid="about-highlights">
        <div className="container mx-auto px-6 md:px-10">
          <div className="max-w-3xl mb-14">
            <p className="font-heading text-xs md:text-sm font-bold tracking-[0.3em] text-[#DC2626] uppercase mb-3">
              מעטפת מלאה
            </p>
            <h2 className="font-heading text-4xl md:text-5xl font-black text-white uppercase tracking-tight leading-[0.95]">
              מעבר לאימונים
            </h2>
            <p className="font-body text-base md:text-lg text-neutral-400 mt-4 leading-relaxed">
              האקדמיה מספקת לספורטאים את כל מה שהם צריכים — לימודים, מגורים, תזונה ותמיכה אישית — כדי שיוכלו להתמקד בלהיות הטובים ביותר על המגרש.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {HIGHLIGHTS.map((h, i) => (
              <div
                key={h.title}
                className="group bg-[#171717] border border-white/10 hover:border-[#DC2626]/50 p-8 flex gap-5 transition-all duration-300"
                data-testid={`about-highlight-${i}`}
              >
                <div className="w-12 h-12 inline-flex items-center justify-center bg-[#DC2626]/15 border border-[#DC2626]/30 text-[#DC2626] flex-shrink-0">
                  <h.icon size={22} strokeWidth={2.5} />
                </div>
                <div>
                  <h3 className="font-heading text-xl font-bold text-white mb-2">{h.title}</h3>
                  <p className="font-body text-sm md:text-base text-neutral-400 leading-relaxed">
                    {h.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Boarding School - Ein Karmit */}
      <section className="py-24 md:py-28 bg-[#050505]" data-testid="boarding-school-section">
        <div className="container mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
            <div className="lg:col-span-4 lg:sticky lg:top-28">
              <div className="bg-white p-8 flex items-center justify-center mb-6">
                <img
                  src="https://customer-assets.emergentagent.com/job_hapoel-court-hub/artifacts/x1e54f19_%D7%9C%D7%95%D7%92%D7%95%20%D7%A2%D7%99%D7%9F%20%D7%9B%D7%A8%D7%9E%D7%99%D7%AA.png"
                  alt="פנימיית עין כרמית"
                  className="w-full max-w-[260px] h-auto object-contain"
                />
              </div>
              <p className="font-heading text-xs font-bold tracking-[0.3em] text-[#DC2626] uppercase mb-3">
                הפנימיה
              </p>
              <h2 className="font-heading text-4xl md:text-5xl font-black text-white uppercase tracking-tight leading-[0.95]">
                פנימיית
                <br />
                <span className="text-[#DC2626]">עין כרמית</span>
              </h2>
              <div className="mt-6 grid grid-cols-2 gap-3 max-w-sm">
                <div className="bg-[#171717] border border-white/10 p-4">
                  <div className="font-heading text-2xl md:text-3xl font-black text-[#DC2626]">130</div>
                  <div className="font-body text-xs text-neutral-400 mt-1">חניכים וחניכות</div>
                </div>
                <div className="bg-[#171717] border border-white/10 p-4">
                  <div className="font-heading text-2xl md:text-3xl font-black text-[#DC2626]">14</div>
                  <div className="font-body text-xs text-neutral-400 mt-1">מוסדות חינוך</div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-8 space-y-5 font-body text-base md:text-lg text-neutral-300 leading-relaxed">
              <p>
                <strong className="text-white">פנימיית עין כרמית</strong> נמצאת במטה יהודה שבהרי ירושלים. בפנימייה מתחנכים 130 חניכים וחניכות. חניכי הפנימייה לומדים בבית הספר החקלאי עין כרם הנמצא בקמפוס משותף, הכולל משק חקלאי, בית ספר יסודי ומרחבים ירוקים.
              </p>
              <p>
                בפנימייה מושם דגש מיוחד על למידה בבית הספר לצד חינוך לערכים <strong className="text-white">באווירה משפחתית, כפרית ועוטפת</strong>.
              </p>
              <p>
                פנימיית עין כרמית חותרת למימוש הפוטנציאל הלימודי של חניכיה. בפנימייה ניתנת עזרה לימודית אישית לכל חניך וחניכה באמצעות שעורי עזר פרטניים, הקניית אסטרטגיית למידה לבעלי לקויות למידה ושיעורים המועברים על ידי מורים מקצועיים ומיומנים בכל המקצועות הנדרשים. כמו כן, ישנם מרכזי למידה בשעות אחה״צ לכלל שכבות הגיל בפנימייה. כל אלו מאפשרים לימודים איכותיים והישגים מרשימים בבחינות הבגרות.
              </p>
              <p>
                הפנימיה הינה בבעלות <strong className="text-white">האגודה לקידום החינוך ירושלים</strong>, ארגון ללא כוונת רווח, שנוסד בשנת 1962 במטרה לצמצם את הפערים החברתיים והחינוכיים בישראל ולטפח מצוינות לימודית וערכית בקרב בני נוער. לאגודה 14 מוסדות חינוך על-יסודיים — בתי ספר ופנימיות. המוסדות מגוונים באופיים, בחזונם ובמבניהם, והם פרושים בירושלים, בכפר אדומים, בכפר-סבא ובנתניה. בנוסף, האגודה יוזמת ומפתחת תכניות פדגוגיות חדשניות ומבצעת פרויקטים ארציים ובינלאומיים בתחום העלייה והקליטה.
              </p>
              <p>
                לאגודה ניסיון רב ועשיר בפיתוח <strong className="text-white">מודלים חינוכיים ייחודיים</strong> המאפשרים לתלמידות ולתלמידים לעצב לעצמם את עתידם ולקדם את השתלבותם בחברה הישראלית.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Agricultural School */}
      <section className="py-20 md:py-24 bg-[#0A0A0A]" data-testid="school-section">
        <div className="container mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <p className="font-heading text-xs font-bold tracking-[0.3em] text-[#DC2626] uppercase mb-3">
                בית הספר
              </p>
              <h2 className="font-heading text-4xl md:text-5xl font-black text-white uppercase tracking-tight leading-[0.95]">
                בית הספר
                <br />
                <span className="text-[#DC2626]">החקלאי עין כרם</span>
              </h2>
              <p className="font-body text-base md:text-lg text-neutral-300 mt-6 leading-relaxed">
                שחקני האקדמיה לומדים בבית הספר החקלאי עין כרם — בית ספר אזורי וייחודי הממוקם בקמפוס משותף עם הפנימיה. בית הספר מציע מסגרת לימודים איכותית עם מגוון מגמות מוגברות, ומאפשר לספורטאים לשלב לימודים ברמה גבוהה לצד אימוני הכדורסל.
              </p>

              <div className="mt-8">
                <p className="font-heading text-sm font-bold tracking-wider text-white uppercase mb-4">
                  המגמות בבית הספר
                </p>
                <div className="flex flex-wrap gap-3">
                  {[
                    "חינוך גופני (מקצוע מוגבר)",
                    "מדעי המחשב (מוגבר)",
                    "פיזיקה (מוגבר)",
                    "חקלאות (מוגבר)",
                    "ועוד מגמות מגוונות",
                  ].map((m) => (
                    <span
                      key={m}
                      className="inline-flex items-center bg-[#171717] border border-white/10 hover:border-[#DC2626]/50 transition-colors text-white font-body text-sm md:text-base px-4 py-2"
                      data-testid={`school-major-${m}`}
                    >
                      {m}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="bg-white p-8 md:p-10 flex items-center justify-center aspect-square max-w-md mx-auto">
                <img
                  src="https://customer-assets.emergentagent.com/job_hapoel-court-hub/artifacts/cgt4pxdg_%D7%97%D7%A7%D7%9C%D7%90%D7%99%20%D7%A2%D7%99%D7%9F%20%D7%9B%D7%A8%D7%9D.jpg"
                  alt="בית הספר החקלאי עין כרם"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partners strip - logos */}
      <section className="py-16 bg-[#050505] border-y border-white/10" data-testid="partners-section">
        <div className="container mx-auto px-6 md:px-10">
          <p className="font-heading text-xs font-bold tracking-[0.3em] text-[#DC2626] uppercase mb-8 text-center">
            השותפים שלנו
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
            <div className="bg-white border border-white/10 p-6 flex items-center justify-center h-32" data-testid="partner-logo-association">
              <img
                src="https://customer-assets.emergentagent.com/job_hapoel-court-hub/artifacts/hxgj1102_%D7%9C%D7%95%D7%92%D7%95%20%D7%94%D7%90%D7%92%D7%95%D7%93%D7%94%20%D7%9C%D7%A7%D7%99%D7%93%D7%95%D7%9D%20%D7%94%D7%97%D7%99%D7%A0%D7%95%D7%9A.png"
                alt="האגודה לקידום החינוך ירושלים"
                className="max-h-full max-w-full object-contain"
              />
            </div>
            <div className="bg-white border border-white/10 p-6 flex items-center justify-center h-32" data-testid="partner-logo-boarding">
              <img
                src="https://customer-assets.emergentagent.com/job_hapoel-court-hub/artifacts/x1e54f19_%D7%9C%D7%95%D7%92%D7%95%20%D7%A2%D7%99%D7%9F%20%D7%9B%D7%A8%D7%9E%D7%99%D7%AA.png"
                alt="פנימיית עין כרמית"
                className="max-h-full max-w-full object-contain"
              />
            </div>
            <div className="bg-white border border-white/10 p-6 flex items-center justify-center h-32" data-testid="partner-logo-school">
              <img
                src="https://customer-assets.emergentagent.com/job_hapoel-court-hub/artifacts/cgt4pxdg_%D7%97%D7%A7%D7%9C%D7%90%D7%99%20%D7%A2%D7%99%D7%9F%20%D7%9B%D7%A8%D7%9D.jpg"
                alt="בית הספר החקלאי עין כרם"
                className="max-h-full max-w-full object-contain"
              />
            </div>
          </div>
          <p className="font-body text-sm text-neutral-400 leading-relaxed max-w-3xl mx-auto text-center mt-10">
            האקדמיה מופעלת על ידי <strong className="text-white">"הפועל מטה יהודה"</strong>, בשיתוף <strong className="text-white">מועצה אזורית מטה יהודה</strong>, <strong className="text-white">פנימיית עין כרמית</strong> ו<strong className="text-white">בית הספר החקלאי עין כרם</strong>.
          </p>
        </div>
      </section>
    </div>
  );
}
